import { Outlet, useLocation } from "react-router";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Footer from "../Footer";
import Navbar from "../Navbar";
import ErrorBoundary from "../ErrorBoundary";

function Root() {
  const location = useLocation();

  const getPageTitle = () => {
    switch (location.pathname) {
      case "/":
        return "SimSim - Nömrələr";
      case "/catalog":
        return "SimSim - Nömrə Kataloqu";
      case "/about":
        return "SimSim - Haqqımızda";
      case "/contact":
        return "SimSim - Əlaqə";
      case "/stores":
        return "SimSim - Mağazalar";
      case "/order":
        return "SimSim - Sifariş";
      case "/order-result":
        return "SimSim - Ödəniş nəticəsi";
      default:
        return "SimSim";
    }
  };

  const getPageDescription = () => {
    switch (location.pathname) {
      case "/":
        return "Azərbaycan mobil operatorlarının nömrələrini axtarmaq və seçmək üçün rəqəmsal platforma. Azercell, Bakcell və Nar nömrələri.";
      case "/catalog":
        return "SimSim nömrə kataloqu - Azərbaycanın ən böyük mobil nömrə bazası. Xüsusi və yadda qalan nömrələr.";
      case "/about":
        return "SimSim - Azərbaycanın aparıcı mobil nömrə platforması. Bizim haqqımızda ətraflı məlumat.";
      case "/contact":
        return "SimSim ilə əlaqə. Bizimlə əlaqə saxlayın və suallarınızı verin.";
      case "/stores":
        return "SimSim mağazaları - Azərbaycanın bütün regionlarında xidmətinizdəyik.";
      case "/order":
        return "Seçilmiş nömrə üçün sifariş səhifəsi - mağaza məlumatları və əlaqə forması.";
      case "/order-result":
        return "Ödəniş və sifariş nəticə səhifəsi.";
      default:
        return "SimSim - Azərbaycan mobil operatorlarının nömrələrini axtarmaq və seçmək üçün rəqəmsal platforma";
    }
  };

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Helmet>
          <html lang="az" />
          <title>{getPageTitle()}</title>
          <meta name="description" content={getPageDescription()} />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://simsim.az${location.pathname}`} />
          <meta name="keywords" content="SimSim, Azercell, Bakcell, Nar, Azercell Nomreler, Sim Nomreler, Nomreler, Nomre, Nomre Al, Nomre Sat, Onlayn Kataloq, Reqemsal Kataloq" />
          <meta name="author" content="SimSim" />
          <meta name="theme-color" content="#000000" />
          <meta name="mobile-web-app-capable" content="yes" />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta name="apple-mobile-web-app-status-bar-style" content="black" />
          <meta name="apple-mobile-web-app-title" content="SimSim" />
          
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://simsim.az${location.pathname}`} />
          <meta property="og:title" content="SimSim - Nömrə alverində yeni dövr!" />
          <meta property="og:description" content="Nömrələrin dünyasına açılan qapı - SimSim ilə nömrəni seç, fərqlən!" />
          <meta property="og:image" content="https://simsim.az/src/assets/og_image.png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:locale" content="az_AZ" />
          <meta property="og:site_name" content="SimSim" />
          
          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={`https://simsim.az${location.pathname}`} />
          <meta name="twitter:title" content="SimSim - Nömrə alverində yeni dövr!" />
          <meta name="twitter:description" content="Nömrələrin dünyasına açılan qapı - SimSim ilə nömrəni seç, fərqlən!" />
          <meta name="twitter:image" content="https://simsim.az/src/assets/og_image.png" />
        </Helmet>
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default Root;
